import { StringIndexable } from 'core/utilities/interface-helpers';
import SharedTableBody from './table-body/table-body';
import SharedTableHead from './table-head/table-head';
import { ISharedTable, ISharedTableCustomCellTemplate } from './table-interface';
import Lozenge from '@atlaskit/lozenge';
import SharedButton from '../buttons/button';

const SharedTable = <T extends StringIndexable>({
  columns,
  customTemplates = [],
  rows,
  isLoading = false,
  loadMoreButton,
  onRowClick,
  draggable = false,
  onReorder,
}: ISharedTable<T>) => {
  const textCellTemplate = (data: string) => <p>{data}</p>;
  const booleanCellTemplate = (data: boolean) => (
    <Lozenge appearance={data ? 'success' : 'removed'}>{data ? 'Active' : 'Inactive'}</Lozenge>
  );

  const templates: ISharedTableCustomCellTemplate[] = [
    {
      template: textCellTemplate,
      id: 'text',
    },
    {
      template: booleanCellTemplate,
      id: 'boolean',
    },
    ...customTemplates,
  ];
  return (
    <>
      <div className='bg-white w-full rounded-md shadow-md overflow-x-auto'>
        <table className={`w-full ${loadMoreButton && rows.length !== 0 ? 'border-b' : ''}`}>
          <SharedTableHead columns={columns} />
          <SharedTableBody
            rows={rows}
            templates={templates}
            columns={columns}
            isLoading={isLoading}
            onRowClick={onRowClick}
            draggable={draggable}
            onReorder={onReorder}
          />
        </table>
        {rows.length === 0 && !isLoading && (
          <div className={`border-t ${loadMoreButton ? 'border-b' : ''}`}>
            <p className='body-02 p-6 text-center'>No results</p>
          </div>
        )}
        {loadMoreButton && (
          <div className='body-02 p-3 flex justify-center w-full'>
            <SharedButton {...loadMoreButton} />
          </div>
        )}
      </div>
    </>
  );
};

export default SharedTable;
